module.exports = __webpack_public_path__ + "img/machine_l_bg.9d9a9dc4.jpg";